import {Injectable} from '@angular/core';
import {Http, Response, Headers, URLSearchParams} from '@angular/http';

import {Observable} from "rxjs/Observable";
import 'rxjs/add/operator/map';

import {Audit} from "./audit";
import {AuditFilter} from "./audit-filter";

@Injectable()
export class AuditService {

    private baseUrl: string = '../audits';
    private actionBaseUrl: string = '../audits/actions';
    private exportBaseUrl: string = '../audits/export';

    constructor(private http : Http) {}

    getPage(filter: AuditFilter): Observable<Audit>{
        let myParams = this.buildParams(filter);
        let myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');

        return this.http
            .get(`${this.baseUrl}`, { headers: myHeaders, search: myParams })
            .map(this.mapAudit);
    }

    getReport(filter: AuditFilter) {
        let myParams = this.buildParams(filter);
        let url = `/cars-sara-v2/audits/export?${myParams}`;
        window.open(url);
    }

    getActions(): any {
        let myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        return this.http
            .get(`${this.actionBaseUrl}`, { headers: myHeaders})
            .map(this.mapActions);
    }

    private buildParams(filter) {
        let myParams = new URLSearchParams();
        if(filter != null){
            if(filter.companyOid!=undefined){
                myParams.append('companyOID', filter.companyOid.toString());
            }
            if(filter.page!=undefined){
                myParams.append('page', filter.page.toString());
            }
            if(filter.offset!=undefined){
                myParams.append('size', filter.offset.toString());
            }
            if(filter.action!=undefined && filter.action!=""){
                myParams.append('action', filter.action.toString());
            }
            if(filter.filterPeriod.from!=undefined && filter.filterPeriod.from!=""){
                myParams.append('dateFrom', filter.filterPeriod.from.toString());
            }
            if(filter.filterPeriod.to!=undefined && filter.filterPeriod.to!=""){
                myParams.append('dateTo', filter.filterPeriod.to.toString());
            }
            if(filter.language!=undefined && filter.language!=""){
                myParams.append('language', filter.language.toString());
            }
        }
        return myParams;
    }

    private mapAudit(response:Response): Audit{
        let body = response.json();
        return body || { };
    }


    private mapActions(response:Response): string[]{
        let body = response.json();
        return body || [];
    }

    private getHeaders(){
        // I included these headers because otherwise FireFox
        // will request text/html instead of application/json
        let headers = new Headers();
        headers.append('Accept', 'application/json');
        return headers;
    }

    getBaseUrl(){
        return this.baseUrl;
    }
}



// WEBPACK FOOTER //
// ./public/upgrade/feature/audit/audit.service.ts